import { render } from "./CycleMetadata.vue?vue&type=template&id=c4f109d0&scoped=true"
import script from "./CycleMetadata.vue?vue&type=script&lang=js"
export * from "./CycleMetadata.vue?vue&type=script&lang=js"

import "./CycleMetadata.vue?vue&type=style&index=0&id=c4f109d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f109d0"]])

export default __exports__